<template>
    <mc-layout title="页面已迁移">
        <div
            slot="content"
            class="deprecated-page"
        >
            <div
                v-if="config.showGuide"
                class="deprecated-container"
            >
                <div class="deprecated-icon">
                    <i class="mtdicon mtdicon-warning-circle"></i>
                </div>
                <h1
                    class="deprecated-title"
                >
                    页面已迁移
                </h1>
                <p
                    class="deprecated-tip"
                >
                    <i class="mtdicon mtdicon-info-circle"></i> 如果您已将本页面添加到浏览器书签，请更新书签地址。
                </p>
                <div
                    v-if="config.showGuide"
                    class="deprecated-guide"
                >
                    <div
                        v-if="countdown > 0"
                        class="countdown"
                    >
                        <span
                            class="countdown-text"
                        >{{ countdown }}</span> 秒后自动跳转
                    </div>
                    <div
                        v-else
                        class="redirect-text"
                    >
                        正在跳转...
                    </div>
                </div>
                <div
                    class="deprecated-actions"
                >
                    <mc-button
                        type="primary"
                        size="large"
                        @click="handleRedirect"
                    >
                        立即跳转到新页面
                    </mc-button>
                </div>
            </div>
        </div>
    </mc-layout>
</template>

<script>
import { getParams } from '@lsfe/tools';

export default {
    name: 'DeprecatedPage',
    data() {
        return {
            // 页面配置
            config: {
                // 跳转目标页面路径 - 必填
                // 注意：只配置路径部分，不需要-alias，query 参数会自动从当前页面获取并保持一致
                targetUrl: '',
                // 是否展示引导和倒计时 - true（展示引导和倒计时）false（立即跳转）
                showGuide: true,
                // 倒计时秒数 - 默认 10 秒
                countdownSeconds: 10,
            },
            // 倒计时
            countdown: 999,
            // 定时器
            timer: null,
        };
    },
    mounted() {
        // 如果配置了展示引导，则启动倒计时
        if (this.config.showGuide) {
            this.countdown = this.config.countdownSeconds;
            this.startCountdown();
        } else {
            // 如果不展示引导，直接跳转
            this.handleRedirect();
        }
    },
    beforeDestroy() {
        // 清理定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        // 启动倒计时
        startCountdown() {
            this.timer = setInterval(() => {
                this.countdown = this.countdown - 1;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                    this.handleRedirect();
                }
            }, 1000);
        },
        // 处理跳转
        handleRedirect() {
            const { targetUrl } = this.config;
            if (!targetUrl) {
                this.$message.error('跳转地址未配置');
                return;
            }
            // 获取当前页面的 query 参数，保持参数一致
            // 使用 @lsfe/tools 的 getParams() 方法获取所有 query 参数
            const currentParams = getParams();
            // 使用 linkTo 方法跳转，传入当前页面的 query 参数
            this.$tools.linkTo(targetUrl, currentParams);
        },
    },
};
</script>

<style scoped lang="scss">
// 使用系统统一的配色方案
.deprecated-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.deprecated-container {
    background: #ffffff;
    border-radius: 4px; // 更小的圆角，更商务化
    padding: 48px 40px;
    max-width: 600px;
    width: 100%;
    text-align: center;
}

.deprecated-icon {
    font-size: 108px;
    line-height: 1;
    color: #E6A23C; // 使用系统的警告色
    margin-bottom: 24px;
    i {
        display: inline-block;
    }
}

.deprecated-title {
    font-size: 24px;
    font-weight: 500;
    color: #333;
    margin: 0 0 16px;
    line-height: 1.5;
}

.deprecated-tip {
    font-size: 13px;
    color: #909399;
    line-height: 1.6;
    margin: 0 0 24px;
    padding: 10px 12px;
    background: #fef0f0;
    border-left: 3px solid #F56C6C; // 使用系统的危险色
    border-radius: 2px;
    text-align: left;

    i {
        margin-right: 4px;
        color: #F56C6C;
        font-size: 14px;
    }
}

.deprecated-guide {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 24px;

    .guide-text {
        font-size: 14px;
        color: #606266;
        margin: 0 0 12px;

        .contact-name {
            color: #409EFF; // 使用系统的主题色
            font-weight: 500;
        }
    }

    .countdown {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #909399;

        .countdown-text {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            background: #409EFF; // 使用系统的主题色
            color: #ffffff;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            margin: 0 6px;
        }
    }

    .redirect-text {
        font-size: 14px;
        color: #409EFF;
        font-weight: 500;
    }
}

.deprecated-actions {
    margin-top: 24px;
}

// 响应式设计
@media (max-width: 768px) {
    .deprecated-container {
        padding: 32px 24px;
    }

    .deprecated-icon {
        font-size: 72px;
        margin-bottom: 20px;
    }

    .deprecated-title {
        font-size: 20px;
    }

    .deprecated-message {
        font-size: 13px;
    }
}
</style>
